// extracted by mini-css-extract-plugin
export default {"section":"styles_section__WQjCd","heading":"styles_heading__5lEHx","para":"styles_para__yOh1M"};